import { render, staticRenderFns } from "./Foundation.vue?vue&type=template&id=c7bc8d60&scoped=true&"
import script from "./Foundation.vue?vue&type=script&lang=js&"
export * from "./Foundation.vue?vue&type=script&lang=js&"
import style0 from "./Foundation.vue?vue&type=style&index=0&id=c7bc8d60&lang=scss&scoped=true&"
import style1 from "./Foundation.vue?vue&type=style&index=1&id=c7bc8d60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7bc8d60",
  null
  
)

export default component.exports